import { axiosClient } from '@lib/axiosClient';

export interface IApp {
  id?: string;
  slug: string;
  integrationType: string;
  category: object;
  name: string;
  description: string;
  tags?: string[];
  target?: string;
  url: string;
  hidden?: boolean;
  public?: boolean;
  platforms?: string[];
  orderIndex: number;
  allowedGroups?: string[];
  allowedRoles?: string[];
  allowedScopes?: string[];
}

export interface IAppId {
  id: string;
}

export async function getAppIdBySlug(slug: string): Promise<IAppId> {
  const response = await axiosClient.get<IAppId>(`/v1/app/id/${slug}`);

  return response.data;
}

export async function getApps(accessToken: string): Promise<IApp[]> {
  const response = await axiosClient.get<IApp[]>('/v1/app', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.data;
}
